const scriptPromises = new Map<string, Promise<void>>();

interface ScriptOptions {
  key: string;
  src: string;
  attributes?: Record<string, string>;
}

export function loadExternalScript({ key, src, attributes = {} }: ScriptOptions): Promise<void> {
  const existingPromise = scriptPromises.get(key);
  if (existingPromise) {
    return existingPromise;
  }

  const script = document.createElement('script');
  script.src = src;
  script.async = true;

  Object.entries(attributes).forEach(([attr, value]) => {
    script.setAttribute(attr, value);
  });

  const promise = new Promise<void>((resolve, reject) => {
    script.addEventListener('load', () => resolve(), { once: true });
    script.addEventListener(
      'error',
      () => {
        scriptPromises.delete(key);
        script.remove();
        reject(new Error(`Failed to load script: ${src}`));
      },
      { once: true },
    );
  });

  scriptPromises.set(key, promise);
  document.head.appendChild(script);

  return promise;
}

export function runInlineScriptOnce(key: string, code: string): void {
  if (scriptPromises.has(key)) {
    return;
  }

  const script = document.createElement('script');
  script.text = code;
  document.head.appendChild(script);
  scriptPromises.set(key, Promise.resolve());
}
